import React from 'react';
import { APP_CONFIG } from '@constants';

const ErrorPage = (props) => {
  return (
      <div className="col-12 h-100">
        <div className="col-12 h-50 text-center py-2 row mx-0 fs-80 align-items-center justify-content-center text-primary">
          Error <i className="fas fa-exclamation-triangle" />
        </div>
        <div className="col-12 row mx-0 h-50 justify-content-center align-items-start">
          <div className="col-6 pl-0">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="w-100 fs-24 rounded od-btn-primary btn-primary btn-ripple btn70"
            >
              Refresh
            </button>
          </div>
          <div className="col-6 pr-0">
            <button
              type="button"
              onClick={() => props.history.replace(`${APP_CONFIG.BASE_URL}/checkIn`)}
              className="w-100 fs-24 rounded od-btn-primary btn-primary btn-ripple btn70"
            >
              Go To Login
            </button>
          </div>
        </div>
      </div>
  );
};

export default ErrorPage;
